import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PanelService } from 'app/shared/panels/chart/Services/panel.service';
import { CommonService } from 'app/shared/services';
import { INavData } from 'app/shared/interfaces/locked-route';
import { ITranslate } from 'app/shared/constants';
import { EViewTypes } from 'app/shared/enums';

@Component({
  selector: 'app-route-nav-lock',
  templateUrl: './route-nav-lock.component.html',
  styleUrls: ['./route-nav-lock.component.css']
})

export class RouteNavLockComponent implements OnInit {
  message: string = '';
  isLockedUrl: boolean = false;
  trans: ITranslate = { text: '' }; // for translation
  private defaultMessage = `All unsaved changes will be lost if you choose to do so.`;

  constructor(private readonly router: Router,
    private readonly commonService: CommonService,
    private readonly translate: TranslateService,
    private readonly panelService: PanelService,
    private readonly dialogRef: MatDialogRef<RouteNavLockComponent, boolean>, @Inject(MAT_DIALOG_DATA)
  public data: INavData) { }

  ngOnInit(): void {
    // translation
    this.translate.onLangChange.subscribe(langChange => this.getTranslation());
    this.getTranslation();
    this.message = this.data?.message ||   this.commonService.translateWord('Component.DialogDefaultMessage')
    console.log(this.data);
  }
     /**
   * get translation
   */
     getTranslation(){
      this.translate.get('Component').subscribe(components => this.trans = components );}

  closeDialog() {
    setTimeout(() => {
      this.router.canceledNavigationResolution = 'computed'; // on back nav, always will go 1 step back at a time
      this.dialogRef.close(false);
    }, 1);
  }

  confirmNavigation() {
    if (this.data?.isLockedUrl) {
      const currentUrl: string = this.router.url;
      // const indexOfFirst: number = currentUrl.indexOf('edit');
      const address: string = currentUrl.includes('edit') ? 'edit' : 'create';
      const indexOfFirst: number = currentUrl.indexOf(address);
      this.router.navigate([currentUrl.substring(1, indexOfFirst - 1)]);
      this.panelService.viewToggle$.subscribe((page: string)=>{
        console.log('page: ', page);
        if(page === EViewTypes.DASHBOARD){
          this.router.navigate(['/dashboard']);
        }
      });
    }

    setTimeout(() => {
      this.dialogRef.close(true);
    }, 1);
  }

}
